<div class="row-module-item">
    <div class="#">
        <span matTooltip="subcity.name">
            {{subcity.name}}
        </span>
    </div>
    <i class="fas fa-trash icon-arrow-container" *ngIf="canDelete" (click)="goToDelete()"></i>
</div>